import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { PageShell } from './components/PageShell';
import { PageTransition } from './components/PageTransition';
import { SmoothScroll } from './components/SmoothScroll';
import { AreaPage } from './pages/AreaPage';
import { AsphaltPage } from './pages/AsphaltPage';
import { AvatarPage } from './pages/AvatarPage';
import { ArtLibraryPage } from './pages/ArtLibraryPage';
import { GalleryPage } from './pages/GalleryPage';
import { HomePage } from './pages/HomePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ProfilePage } from './pages/ProfilePage';

const titles: Record<string, string> = {
  '/artes': 'Artes | Traiano 55789',
  '/artes/': 'Artes | Traiano 55789',
  '/': 'Traiano 55789 | Deputado Estadual',
  '/avatar': 'Crie seu avatar e cards | Traiano 55789',
  '/traiano': 'Traiano | Traiano 55789',
  '/investimentos': 'Investimentos | Traiano 55789',
  '/saude': 'Saúde | Traiano 55789',
  '/infraestrutura': 'Infraestrutura | Traiano 55789',
  '/grandes-obras': 'Grandes obras | Traiano 55789',
  '/galeria': 'Galeria | Traiano 55789',
  '/projetos/asfalto': 'Obras de asfalto | Traiano 55789',
};

export default function App() {
  const location = useLocation();
  useEffect(() => {
    document.title = titles[location.pathname] ?? 'Página não encontrada | Traiano 55789';
  }, [location.pathname]);

  return (
    <>
      <SmoothScroll />
      <PageShell>
        <PageTransition key={location.pathname}>
          <Routes location={location}>
            <Route path="/fontes" element={<Navigate to="/" replace />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/avatar" element={<AvatarPage />} />
            <Route path="/artes" element={<ArtLibraryPage />} />
            <Route path="/traiano" element={<ProfilePage />} />
            <Route path="/investimentos" element={<AreaPage area="investimentos" />} />
            <Route path="/saude" element={<AreaPage area="saude" />} />
            <Route path="/infraestrutura" element={<AreaPage area="infraestrutura" />} />
            <Route path="/grandes-obras" element={<AreaPage area="grandes-obras" />} />
            <Route path="/galeria" element={<GalleryPage />} />
            <Route path="/projetos/asfalto" element={<AsphaltPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </PageTransition>
      </PageShell>
    </>
  );
}
